import axios from 'axios';
import Cookies from 'js-cookie';
import { isEmpty, isString } from 'lodash';
import { toast } from 'react-toastify';

import { routes } from 'router';
import { appService } from 'services';
import {
  resetAuthStore,
  resetCart,
  resetLeisurePurchaseStore,
  resetPersistedCart,
  resetStore,
  resetTravelPurchaseStore,
  store
} from 'store';
import i18n from 'translations';

const apiBaseUrl = appService.getMiddlewareBaseUrl();
const token = !isEmpty(Cookies.get('user')) ? JSON.parse(Cookies.get('user')).token : null;

/**
 * A object to gather all API request methods, to be called to make requests to API
 */
export const apiService = {
  /* A method to construct an API object with its base url and base headers */
  setApi: () => {
    return axios.create({
      baseURL: apiBaseUrl,
      withCredentials: true
    });
  },
  /* A method to add a token to the request */
  addToken: (request) => {
    if (!token) return;
    request.headers = {
      ...request.headers,
      Authorization: token
    };
  },
  /* A method to handle request errors and call the proper error toast */
  handleError: (error) => {
    const errorStatus = error?.response?.status ?? error?.message.replace(' ', '_').toLowerCase();
    apiService.displayToast(errorStatus);
    throw new Error(error);
  },
  /* A method to dispaly the proper error toast */
  displayToast: (error) => {
    /*
      Display API error message for client errors (400, 401, 403, 404, 422)
      Display default error message for other errors
    */
    const clientErrors = [400, 401, 403, 404, 422];
    const { status, body } = error || {};
    if (status !== undefined && status !== 'canceled') {
      const message = clientErrors.includes(status)
        ? body
        : i18n.getResource(i18n.resolvedLanguage, 'dialog', 'requestErrors.default');

      isString(message) && !isEmpty(message) && toast.error(message);
    }
  },
  // A method to handle logout user
  logoutUser: () => {
    store.dispatch(resetStore());
    store.dispatch(resetCart());
    store.dispatch(resetPersistedCart());
    store.dispatch(resetAuthStore());
    store.dispatch(resetTravelPurchaseStore());
    store.dispatch(resetLeisurePurchaseStore());
    window.location.href = routes.login.path;
  }
};
